import { put, delay } from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';

export function* getMultiRouterSaga(action) {
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const divID = yield sessionStorage.getItem('divID');

  yield put(actions.initMultiRouterStart());
  try {
      //console.log('IGETTT MULTIROUTERdd')
      let response = {};
      response = yield axios.get(
        '/multi/allRouterInfo',
      )
      if (response.status === 200) {
        if(response.data.accountType === "COMMERCIAL"){
          sessionStorage.setItem('type', "Business")
        }
        const routersDetails = response.data?.networkTopology?.map((netTop, index) => {
          const { router, modem } = netTop;
          if (router) {
            router.oneSsid = router.ssid.ssid5gHz?router.ssid.ssid5gHz:router.ssid.ssid2gHz?router.ssid.ssid2gHz:"SSID Name"
            // this.setState({ myArray: [...this.state.myArray, 'new value'] })
            return router
          }
        }).filter(Boolean);
        yield put(()=>{response.data.routersDetails = routersDetails})
        yield put(actions.setMultiRouter(response.data))
        yield put(actions.getMultiRouterSuccess());
      } else {
        yield put(actions.getMultiRouterFailed());
      }

    } catch (error) {
      yield put(actions.getMultiRouterFailed());
    }

}

export function* assignPodsSaga(action) {
  const rMac = action.rMac;
  const pSerial = action.serialNumber;
  const ssid = action.ssid;
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
  try {
    //console.log("Check Enable",action)
    yield put(actions.initAssignPodsRequest());

    const response = yield axios.post(
          '/Pod/claim',
          { rMac:action.rMac,
          bToken: token,
          serialNumber: action.serialNumber,
          sessionToken: sessionToken,
          ssid: ssid
        }
        );

        //console.log(response, 'response assign pods')
        if(response?.status === 200){

          yield put(actions.getMultiRouter())
          yield put(actions.assignPodsSuccess(`Extender successfully assigned for SSID: ${ssid} and Serial: ${action.serialNumber}`));
          }else{
            //console.log('FAILED DEVICES')
           yield put(actions.assignPodsFailed(`Error! Extender was not assigned`));
          }

  } catch (error) {
    console.error('CHANGE FREEZE ERROR', error)
    yield put(actions.assignPodsFailed(`Error! Extender was not assigned`));
  }
} else {
  //console.log('NO TOKEN')
  yield put(actions.assignPodsFailed(`Error! Extender was not assigned`));

 }

}


export function* unClaimedPodsSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
  try {
    //console.log("Check Enable",action)
    yield put(actions.initunClaimedPodsRequest());
    const response = yield axios.post(
          '/Pod/unclaim',
          {
          serialNumber: action.serialNumber,
          }
        );

        //console.log(response, 'response unassign pods')
        if(response?.status === 204){
          yield put(actions.unClaimedPodsSuccess(`Extender successfully unassigned for SSID: ${action.ssid} and Serial: ${action.serialNumber}`));
          yield put(actions.getMultiRouter())
          }else{
            //console.log('FAILED DEVICES')
           yield put(actions.unClaimedPodsFailed(`Error! Extender was not unassigned`));
          }

  } catch (error) {
    console.error('CHANGE FREEZE ERROR', error)
    yield put(actions.unClaimedPodsFailed(`Error! Extender was not unassigned`));
  }
} else {
  //console.log('NO TOKEN')
  yield put(actions.unClaimedPodsFailed(`Error! Extender was not unassigned`));

 }
}
